import { render, staticRenderFns } from "./Magazines.vue?vue&type=template&id=335c6f6a&"
import script from "./Magazines.vue?vue&type=script&lang=js&"
export * from "./Magazines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports